import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ArticoliMatricola } from 'src/app/models/articoli-matricola';
import { PrintBarCodeModel } from 'src/app/models/print-barcode-model';
import { StorageService } from './storage.service';
import { Permessi } from 'src/app/models/permessi';
@Injectable({
  providedIn: 'root'
})
export class ArticoliMatricolaService {
  private http = inject(HttpClient);
  private ss = inject(StorageService);


  articoliMatricolaUrl = environment.ildatoArticoliDpi + 'api/articolimatricola';

  list(idArticolo = 0, soloAttivi: boolean = undefined): Observable<ArticoliMatricola[]> {
    if(!this.ss.permessiCorrente.find((x:Permessi) => x.nomeModulo == "Matricole")){
      return of([]);
    }
    let filter = '';
    if (idArticolo != null && idArticolo > 0) {
      filter += 'IdArticolo=' + idArticolo + '&';
    }
    if (soloAttivi != null) {
      filter += 'SoloAttivi=' + soloAttivi + '&';
    }  
    if (filter.length > 0) {
      filter = '?' + filter.slice(0,-1).trim();
    }
    return this.http.get<ArticoliMatricola[]>(this.articoliMatricolaUrl + filter);
  }

  listDisponibili(idArticolo = 0): Observable<ArticoliMatricola[]> {
    if(!this.ss.permessiCorrente.find((x:Permessi) => x.nomeModulo == "Matricole")){
      return of([]);
    }
    let filter = '';
    if (idArticolo != null && idArticolo > 0) {
      filter += 'IdArticolo=' + idArticolo + '&';
    }
    if (filter.length > 0) {
      filter = '?' + filter.slice(0,-1).trim();
    }
    return this.http.get<ArticoliMatricola[]>(this.articoliMatricolaUrl + '/disponibili' + filter);
  }

  listAssegnati(idArticolo = 0, idDipendente = 0): Observable<ArticoliMatricola[]> {
    if(!this.ss.permessiCorrente.find((x:Permessi) => x.nomeModulo == "Matricole")){
      return of([]);
    }
    let filter = '';
    if (idArticolo != null && idArticolo > 0) {
      filter += 'IdArticolo=' + idArticolo + '&';
    }
    if (idDipendente != null && idDipendente > 0) {
      filter += 'IdDipendente=' + idDipendente + '&';
    }
    if (filter.length > 0) {
      filter = '?' + filter.slice(0,-1).trim();
    }
    return this.http.get<ArticoliMatricola[]>(this.articoliMatricolaUrl + '/assegnati' + filter);
  }

  listConAlert(idArticolo = 0): Observable<ArticoliMatricola[]> {
    if(!this.ss.permessiCorrente.find((x:Permessi) => x.nomeModulo == "Matricole")){
      return of([]);
    }
    let filter = '';
    if (idArticolo != null && idArticolo > 0) {
      filter += 'IdArticolo=' + idArticolo + '&';
    }
    if (filter.length > 0) {
      filter = '?' + filter.slice(0,-1).trim();
    }
    return this.http.get<ArticoliMatricola[]>(this.articoliMatricolaUrl + '/conAlert' + filter);
  }

  get(id:number): Observable<ArticoliMatricola> {
    if(!this.ss.permessiCorrente.find((x:Permessi) => x.nomeModulo == "Matricole")){
      return of();
    }
    return this.http.get<ArticoliMatricola>(this.articoliMatricolaUrl  + '/'+ id);
    
  }

  getByRef(idArticolo:number, matricola: string): Observable<ArticoliMatricola> {
    if(!this.ss.permessiCorrente.find((x:Permessi) => x.nomeModulo == "Matricole")){
      return of();
    }
    return this.http.get<ArticoliMatricola>(this.articoliMatricolaUrl  + '/byRef/'+ idArticolo + '/' + matricola);
    
  }

  insert(values: ArticoliMatricola): Observable<ArticoliMatricola> {
    if(!this.ss.permessiCorrente.find((x:Permessi) => x.nomeModulo == "Matricole")){
      return of();
    }
    console.log(values);    
    return this.http.post<ArticoliMatricola>(this.articoliMatricolaUrl, values);
  }

  remove(id: number): Observable<ArticoliMatricola> {
    if(!this.ss.permessiCorrente.find((x:Permessi) => x.nomeModulo == "Matricole")){
      return of();
    }
    console.log(id);    
    return this.http.delete<ArticoliMatricola>(this.articoliMatricolaUrl + '/'+ id );
  }

  update(key: number, values: ArticoliMatricola): Observable<ArticoliMatricola> {
    if(!this.ss.permessiCorrente.find((x:Permessi) => x.nomeModulo == "Matricole")){
      return of();
    }
    console.log(values);    
    return this.http.put<ArticoliMatricola>(this.articoliMatricolaUrl + '/'+ key , values);
  }

  stampaEtichette(barCodeModel: PrintBarCodeModel): Observable<Blob> {
    if(!this.ss.permessiCorrente.find((x:Permessi) => x.nomeModulo == "Matricole")){
      return of();
    }
    return this.http.post(
      this.articoliMatricolaUrl + '/stampeEtichette',
      barCodeModel,
      {
        responseType: 'blob',
      },
    );
  }
}
